export default __webpack_public_path__ + "static/media/Colac_colour_logo.b67fefdf.svg";